<template>
  <div class="product">
    <title>深圳市微云腾|定制建站|logo设计|平面设计|SEO优化</title>
    <meta name="keywords" content="深圳市微云腾科技有限公司,专业建站,模板定制建站,全定制建站,logo设计,平面设计">
    <!-- 产品第一部分 -->
    <div class="pfirst">
      <img src="../assets/product/product.png" alt class="pyy" />
      <div class="pbgc"></div>
      <div class="pdbyy"></div>
      <div class="pbig">
        <div class="contaniner">
          <div class="pnav">
            <Navbar></Navbar>
          </div>
          <div class="pneirong">
            <div class="pleft">
              <p>BUSINESS</p>
              <p style="color:#24C0EA;font-size:20px; width:100px;">产品与服务</p>
            </div>
            <div class="pright">
              <span>
                <p>我们的服务不论项目大小，只要客户和我们对品质有着共同的追求，对于我们，每一次设计和实施的过程都是一次愉悦的体验。</p>
              </span>
              <p>我们相信品牌要获得实效，创意是强有力的解决武器，我们会将创意贯穿于我们的设计中。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 产品第二部分 -->
    <div class="psecond">
      <img src="../assets/product/wzjs.jpg" alt="网站建设" class="psbgc" />
      <div class="psneirong">
        <p style="color:#24C0EA;font-size:48px;font-weight: 600">企业网站建设</p>
        <br />
        <p style="color:#333333;font-size:20px;">
          品牌网站创意设计 | 企业集团网站建设
          活动专题创意设计 | 电商门户网站设计
        </p>
      </div>
    </div>
    <!-- 产品第三部分 -->
    <div class="pthree">
      <img src="../assets/product/wzwh.jpg" alt="网站维护" class="ptbgc" />
      <div class="ptneirong">
        <p style="color:#24C0EA;font-size:48px;font-weight: 600">企业网站维护</p>
        <br />
        <p style="color:#333333;font-size:20px;">网站挂马清除 | 网络安全监控</p>
        <p style="color:#333333;font-size:20px;">内容维护上传 | SEO关键词优化</p>
      </div>
    </div>
    <!-- 产品第四部分 -->
    <div class="pfour">
      <img src="../assets/product/pmsj.jpg" alt="SDWAN跨境组网专线" class="pfbgc" />
      <div class="pfneirong">
        <p style="color:#24C0EA;font-size:48px;font-weight: 600">SDWAN跨境组网专线</p>
        <br />
        <p style="color:#333333;font-size:20px;">
          国内组网专线 | 跨境组网专线
        </p>
        <p style="color:#333333;font-size:20px;">
          全球组网专线   | SDWAN做跨境组网
        </p>
      </div>
    </div>
    <!-- 产品第五部分 -->
    <div class="pfive">
      <img src="../assets/product/jmsj.jpg" alt="jmsj" class="pwbgc" />
      <div class="pwneirong">
        <p style="color:#24C0EA;font-size:48px;font-weight: 600">SDWAN跨境专线</p>
        <br />
        <p style="color:#333333;font-size:20px;">低延迟出海 | 0丢包访问</p>
        <p style="color:#333333;font-size:20px;">网络更快更稳定 | 售后无忧</p>
      </div>
    </div>
    <div class="pfoot">
      <Footer></Footer>
    </div>
  </div>
</template>
<style lang="scss" scope>
.product {
  .contaniner {
    width: 1200px;
    margin: 0 auto;
  }
  // 产品第一部分
  .pfirst {
    width: 100%;
    height: 844px;
    position: relative;
    .pyy {
      width: 100%;
      height: 844px;
      filter: blur(1px);
    }
    .pbgc {
      width: 100%;
      height: 844px;
      background-color: #000;
      opacity: 0.5;
      position: absolute;
      top: 0;
    }
    .pdbyy {
      width: 100%;
      height: 350px;
      background-color: #000;
      opacity: 0.5;
      position: absolute;
      bottom: 0;
    }
    .pbig {
      width: 100%;
      height: 844px;
      position: absolute;
      top: 0;
      .pnav {
        width: 100%;
        height: 100px;
      }
      .pneirong {
        width: 100%;
        height: 210px;
        margin-top: 464px;
        .pleft {
          width: 228px;
          height: 130px;
          font-size: 48px;
          color: #bbbbbb;
          float: left;
        }
        .pright {
          width: 760px;
          height: 210px;
          float: right;
          span {
            display: block;
            width: 100%;
            height: 125px;
            color: #bbbbbb;
          }
          p {
            color: #bbbbbb;
          }
        }
      }
    }
  }
  // 产品第二部分
  .psecond {
    width: 100%;
    height: 978px;
    position: relative;
    .psbgc {
      width: 100%;
      height: 978px;
    }
    .psneirong {
      width: 350px;
      height: 300px;
      z-index: 3;
      position: absolute;
      left: 360px;
      top: 715px;
    }
  }
  // 产品第三部分
  .pthree {
    width: 100%;
    height: 978px;
    position: relative;
    .ptbgc {
      width: 100%;
      height: 978px;
    }
    .ptneirong {
      width: 350px;
      height: 300px;
      position: absolute;
      top: 567px;
      right: 240px;
    }
  }
  // 产品第四部分
  .pfour {
    width: 100%;
    height: 978px;
    position: relative;
    .pfbgc {
      width: 100%;
      height: 978px;
    }
    .pfneirong {
      width: 350px;
      height: 300px;
      position: absolute;
      top: 567px;
      left: 360px;
    }
  }
  // 产品第五部分
  .pfive {
    width: 100%;
    height: 978px;
    position: relative;
    .pwbgc {
      width: 100%;
      height: 978px;
    }
    .pwneirong {
      width: 350px;
      height: 300px;
      position: absolute;
      top: 567px;
      right: 240px;
    }
  }
}
</style>
<script>
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
export default {
  data() {
    return {};
  },
  methods: {},
  components: {
    Navbar,
    Footer
  }
};
</script>